/**
 * Container card built on the `.card` component class. Optional title bar with
 * an actions slot on the right.
 */
import type { ReactElement, ReactNode } from 'react';

export interface CardProps {
  title?: ReactNode;
  /** Right-aligned actions rendered in the title bar. */
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
  bodyClassName?: string;
}

/** Padded, bordered content card with an optional header row. */
export default function Card({
  title,
  actions,
  children,
  className = '',
  bodyClassName = '',
}: CardProps): ReactElement {
  return (
    <section className={`card ${className}`.trim()}>
      {(title || actions) && (
        <header className="mb-4 flex items-center justify-between gap-3">
          {title && <h2 className="text-base font-semibold text-gray-900">{title}</h2>}
          {actions && <div className="flex items-center gap-2">{actions}</div>}
        </header>
      )}
      <div className={bodyClassName}>{children}</div>
    </section>
  );
}
